export default __webpack_public_path__ + "static/media/snlc-logo.c0ad1536.png";